import { getServerErrorsUrl } from '../config/apiConfig';

export async function fetchServerErrors({ origin = 'all', error_type = 'all', since_hours = 168 } = {}) {
  const params = new URLSearchParams();
  if (origin && origin !== 'all') params.set('origin', origin);
  if (error_type && error_type !== 'all') params.set('error_type', error_type);
  if (since_hours) params.set('since_hours', String(since_hours));

  const url = `${getServerErrorsUrl()}?${params.toString()}`;
  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) {
      return { error: `Errors API returned ${response.status}`, data: null };
    }
    const data = await response.json();
    return { error: null, data };
  } catch (e) {
    return { error: e.message || 'Failed to fetch server errors', data: null };
  }
}
